import React from 'react';
import { painPoints } from '../data/salesContent';
export function Agitation() {
  return <section className="bg-bone px-5 py-14 sm:px-8" data-id="element-13" data-mp="3lasol6u8bjhs">
      <div className="mx-auto grid max-w-5xl gap-10 lg:grid-cols-2 lg:items-center lg:gap-16" data-id="element-14" data-mp="3la170zxgvmai">
        <div data-id="element-15" data-mp="33v4spjl4blq">
          <h2 className="font-display text-[24px] font-bold leading-tight text-plum sm:text-[32px]" data-id="element-16" data-mp="32bpb15r64l0">
            ¿Tu cuerpo lleva meses gritándote y nadie entiende por qué?
          </h2>
          <p className="mt-4 max-w-xl text-[15px] leading-relaxed text-neutral-700 sm:text-[16px]" data-id="element-17" data-mp="37j4hxj2r1n87">
            Te despiertas con el cuello rígido, la gastritis no te da tregua y los análisis dicen
            que estás bien. No es tu imaginación. Es tu sistema nervioso colapsando bajo emociones
            no procesadas. La buena noticia: puedes resetearlo en 7 minutos al día.
          </p>
        </div>

        <div className="rounded-2xl border border-plum/10 bg-white p-6 shadow-[0_10px_30px_-22px_rgba(45,27,78,0.5)]" data-id="element-18" data-mp="2nsspzxa949qs">
          <p className="text-[11px] font-black uppercase tracking-[0.12em] text-plum/70" data-id="element-19" data-mp="37pk83htvboud">
            ¿Reconoces alguno de estos?
          </p>
          <ul className="mt-4 space-y-2.5" data-id="element-20" data-mp="3cn2ilcnjac4h">
            {painPoints.map(item => <li key={item} className="flex gap-2.5 text-[14px] text-neutral-800 sm:text-[15px]" data-id="element-21" data-mp="3hg536vac2b8j">
                <span aria-hidden="true" className="font-black text-red-600" data-id="element-22" data-mp="3md5blcunnq2t">
                  ✗
                </span>
                {item}
              </li>)}
          </ul>
          <p className="mt-5 border-t border-neutral-200 pt-4 text-[14px] font-bold text-emerald-deep" data-id="element-23" data-mp="2topywwyzxjun">
            Si marcaste 2 o más, este manual es para ti.
          </p>
        </div>
      </div>
    </section>;
}